import request from '@/utils/request'

// 查询空间停留汇总列表
export function listSpaceStay(query) {
  return request({
    url: '/system/space-stay/list',
    method: 'get',
    params: query,
  })
}

// 查询空间停留汇总分页
export function pageSpaceStay(query) {
  return request({
    url: '/system/space-stay/page',
    method: 'get',
    params: query,
  })
}

// 查询空间停留汇总详细
export function getSpaceStay(data) {
  return request({
    url: '/system/space-stay/detail',
    method: 'get',
    params: data,
  })
}

// 新增空间停留汇总
export function addSpaceStay(data) {
  return request({
    url: '/system/space-stay/add',
    method: 'post',
    data: data,
  })
}

// 修改空间停留汇总
export function updateSpaceStay(data) {
  return request({
    url: '/system/space-stay/edit',
    method: 'post',
    data: data,
  })
}

// 删除空间停留汇总
export function delSpaceStay(data) {
  return request({
    url: '/system/space-stay/delete',
    method: 'post',
    data: data,
  })
}
